export default __webpack_public_path__ + "static/media/Group841.1d03c8eb.svg";